/* SET ERROR ON FORM */
window.setErrors = function (formEl, errors) {
    formEl.classList.add("was-validated");

    for (var key in errors) {
        if (key == "ville") {
            var input = formEl.querySelector('[name="filler"] ');
            input.setCustomValidity(errors[key][0]);

            var feedback = formEl.querySelector("#villeMsg");
            feedback.innerHTML = errors[key][0];
        } else if (key == "optin") {
            formEl
                .querySelectorAll('[name="' + "optin" + '"]')
                .forEach(function (input) {
                    input.setCustomValidity(errors[key][0]);
                    var feedback = formEl.querySelector("#optinMsg");

                    if (feedback.classList.contains("invalid-feedback")) {
                        feedback.innerHTML = errors[key][0];
                    }
                });
        } else if (key == "civilite") {
            formEl
                .querySelectorAll('[name="' + "civilite" + '"]')
                .forEach(function (input) {
                    input.setCustomValidity(errors[key][0]);
                    var feedback = formEl.querySelector("#civiliteMsg");

                    if (feedback.classList.contains("invalid-feedback")) {
                        feedback.innerHTML = errors[key][0];
                    }
                });
        } else {
            var el = formEl
                .querySelectorAll('[name="' + key + '"]')
                .forEach(function (input) {
                    input.setCustomValidity(errors[key][0]);
                    var feedback = input.nextElementSibling;

                    if (feedback.classList.contains("invalid-feedback")) {
                        feedback.innerHTML = errors[key][0];
                    }
                });
        }
    }
};

/* CLEAR FORM ERRORS*/
function clearErrors(formEl) {
    formEl.querySelectorAll("input").forEach(function (input) {
        input.setCustomValidity("");
    });
}

function gtag_report_conversion(url) {
    var callback = function () {
        if (typeof url != "undefined") {
            window.location = url;
        }
    };
    gtag("event", "conversion", {
        send_to: "AW-342523272/WlGBCKbqq80CEIj7qaMB",
        event_callback: callback,
    });
    return false;
}

window.handleConfirmation = function (status, data) {
    //Vous pouvez à présent télécharger la brochure du programme dans le bloc médias ou en cliquant ci-dessous<br><br>
    // <a href="/img/PRIM_SANNOIS_BRO6P_3V-A4-0221_pap.pdf" target="_blank" type="button" class="font-r">
    //                 Brochure
    //             </a>
    var confTemplate = `
        <div class="form-confirmation" >
            <div class="svg-container mx-auto">
                <img data-src="/img/form-confirm.svg" class="lazyload"/>
            </div>
            <div class="confirmation-message  text-center">
                
                Nous vous remercions de l’intérêt que vous portez <br>à nos programmes immobiliers. <br>
                
                Nous avons bien pris en compte votre demande <br>et reviendrons vers vous rapidement. <br><br>
                
                <div class="d-none">
                    <a href="" target="__blank" id="brochure-link" class="btn btn-link">Pour télécharger votre document, veuillez cliquer ici</a> <br><br>
                </div>
                
                <br> <br>
                
    
            </div>
        </div>`;
    var erreurTemplate = `
        <div class="form-confirmation" data-aos="fade-up" data-aos-delay="200 " data-aos-duration="500" data-aos-once="true">
            <div class="confirmation-message  text-center">
                
                Une erreur est survenue pendant l'enregistrement, veuillez rafraîchir la page et saisir l'ensemble des champs du formulaire
    
                
            </div>
        </div>`;

    document.querySelector("#form").classList.remove("d-flex");
    document.querySelector("#form").classList.add("d-none");

    document.querySelector("#confirmation").classList.remove("d-none");

    if (!status) {
        document.querySelector("#confirmation").innerHTML = erreurTemplate;
    } else {
        document.cookie = "download=true";
        document.querySelector("#confirmation").innerHTML = confTemplate;

        if (window.selectedDoc != "") {
            document.querySelector("#v-pills-brochure-tab").dataset.toggle = "";
            let link = document.getElementById("brochure-link");
            link.parentElement.classList.remove("d-none");
            link.href = window.selectedDoc;
        }

        // Appel à gtag_report_conversion
        if (
            data.program.slug === "les-terrasses-venitiennes" ||
            data.program.slug === "les-meulieres-de-la-tour"
        ) {
            gtag_report_conversion();
        }

        //gtag('event', 'conversion', {'send_to': 'AW-429385595/TYQbCJK47fQBEPvO38wB'});

        //fbq('track', 'Lead');
    }

    //SEND PAGEVIEW ON CONFIRMATION
    dataLayer = window.dataLayer || [];
    dataLayer.push({
        event: "formSubmit",
        // type_demande: demande
    });

    setTimeout(function () {}, 1000);
};

/* SUBMIT FORM */
window.submitForm = function (event) {
    event.preventDefault();
    var form = $(".form-contact");
    var formEl = document.getElementById("form");
    var inputs = $("#form").serialize();
    var url = formEl.action;
    var btnEl = formEl.querySelector('button[type="submit"]');
    var confMl = document.querySelector(".appointment-ml");

    btnEl.setAttribute("disabled", "disabled");
    btnEl.textContent = "Patientez ...";

    // remove errs
    clearErrors(formEl);

    $.ajaxSetup({
        headers: {
            "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content"),
        },
    });

    $.post(url, inputs)
        .done(function (data, statusText, xhr) {
            console.log(xhr, data);
            if (xhr.status === 200) {
                btnEl.removeAttribute("disabled");

                if (data.success) {
                    console.log(data);

                    // Authorize DL FOR PROGRAMS
                    document.cookie =
                        data.program + "=" + (true || "") + "; path=/";
                    window.handleConfirmation(true, data);

                    // Appel à gtag_report_conversion
                    if (
                        data.program.slug === "les-terrasses-venitiennes" ||
                        data.program.slug === "les-meulieres-de-la-tour"
                    ) {
                        gtag_report_conversion();
                    }

                    btnEl.textContent = "Valider";
                } else {
                    window.handleConfirmation(false, data);
                }
            }
        })

        .fail(function (error) {
            var errors = {};

            btnEl.removeAttribute("disabled");
            btnEl.textContent = "Valider";

            if (error.status == 422) {
                errors = error.responseJSON.errors;

                if (Object.keys(errors).length > 0) {
                    window.setErrors(formEl, errors);
                }
            }
        });

    event.preventDefault();
};
